<template>
<div class="number-input" :class="errorClassInputWrap">
  <input type="text"
         autocomplete="new-password"
         v-model="currentValue"
         :placeholder="placeholder"
         :class="errorClassInput"
         :disabled="disabled"
         @input="onChange($event.target.value)"
         @keypress="onKeyPress"
         @focus="onFocus"
         @blur="onLostFocus"
  >
</div>
</template>

<script>
export default {
  name: 'numberInput',
  props: {
    value: {
      type: [String, Number],
      required: true,
    },
    placeholder: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    onlyInteger: {
      type: Boolean,
      default: false,
    },
    fixedNumber: {
      type: Number,
      default: 2,
    },
    error: {
      type: Boolean,
    },
    max: {
      type: Number,
      default: null,
    },
    isShowError: {
      type: Boolean,
      default: false,
    },
  },
  model: {
    event: 'input',
  },
  data() {
    return {
      currentValue: this.value,
      isCurrentDecimal: false,
      timeOut: null,
    };
  },
  watch: {
    value(value) {
      this.setValue(value);
    },
  },
  mounted() {
    this.setValue(this.value);
  },
  computed: {
    isShowColorError() {
      return this.isShowError && this.error;
    },
    errorClassInput() {
      return {
        error: this.error,
        'error-show': this.isShowColorError,
      };
    },
    errorClassInputWrap() {
      return {
        'error-show': this.isShowColorError,
      };
    },
  },
  methods: {
    setValue(value) {
      let result = value;

      if (this.max && value > this.max) {
        result = this.max;
      }

      if (this.onlyInteger) {
        result = parseFloat(result) || 0;
        result = Math.ceil(result);
      } else {
        this.isCurrentDecimal = /\d?\.\d?/.test(result);
        if (this.isCurrentDecimal) {
          const decimalLength = result.toString().includes('.') ? result.toString().split('.').pop().length : 0;
          result = parseFloat(result) || 0;
          if (decimalLength > this.fixedNumber) {
            result = result.toFixed(this.fixedNumber);
          } else {
            result = result.toFixed(decimalLength);
          }
        }
      }

      this.currentValue = result;

      this.$emit('input', result);
    },
    onChange(value) {
      clearTimeout(this.timeOut);
      let result = value;
      const isFiniteString = /^\d+[.,]$/.test(value);

      if (!isFiniteString) {
        result = value.replace(',', '.');
        this.setValue(result);
      }
    },
    onKeyPress($event) {
      const keyCode = $event.key.charCodeAt(0);

      if (this.onlyInteger && [44, 46].includes(keyCode)) {
        $event.preventDefault();
      }

      this.isCurrentDecimal = /\d?[.,]\d?/.test(this.currentValue);
      // Allow: backspace, delete, tab, escape, enter and ./,
      // если уже десятичное число и повторно пытаемся ввести дробную часть
      if ([8, 9, 27, 13, 110, 188, 190, 44, 46].includes(keyCode)
        && !([44, 46].includes(keyCode) && this.isCurrentDecimal)) {
        return;
      }

      if (($event.shiftKey || (keyCode < 48 || keyCode > 57))) {
        $event.preventDefault();
      }
    },
    onFocus() {
      this.$emit('clear-error');
      if (this.currentValue === 0) {
        this.currentValue = '';
      }
    },
    onLostFocus() {
      if (this.currentValue === '') {
        this.currentValue = 0;
      }
    },
  },
};
</script>

<style scoped>
  input {
    width: 100%;
    height: 48px;
    padding-left: 22px;
    padding-right: 12px;
    border: 0;
    border-radius: 4px;
    background-color: #ffffff;
    font-size: 16px;
    font-weight: 300;
    color: black;
  }

  .error-show {
    background-color: #ffe6e6;
  }
</style>
